import React from "react";
import slugify from "slugify";
import styled from "styled-components";

const Heading = styled.h2`
  font-weight: bold;
  font-size: 28px;
  line-height: 1.14;

  a {
    color: inherit !important;
  }

  @media (max-width: 960px) {
    font-size: 24px;
  }
`;

export const Subheader = ({
  children,
  id = typeof children === "string"
    ? slugify(children, {
        lower: true,
      })
    : undefined,
}: JSX.IntrinsicElements["h2"]) => {
  return (
    <Heading id={id}>
      {id ? <a href={`#${id}`}>{children}</a> : children}
    </Heading>
  );
};
